<div class="content" [ngClass]="{ collapsed: !isOpen }" role="menubar">
  <ng-container *ngIf="!isOpen; else expandedMenu">
    <button
      class="title collapsed toggle-button"
      role="button"
      (click)="toggleSidebar()"
      aria-label="Expand sidebar"
    >
      <img
        src="assets/menu-close.svg"
        alt="expand menu icon"
        class="expand-icon"
      />
    </button>
    <nav>
      <ul>
        <li
          *ngFor="let area of therapeuticAreas"
          matTooltip="{{ area.name }}"
          matTooltipPosition="right"
        >
          <a
            class="menu-item-header ta-navigation"
            [routerLink]="['/details', area.name]"
            routerLinkActive="active"
          >
            <div class="area">
              <img
                [src]="'assets/icons/' + area.icon"
                alt="{{ area.name }} icon"
              />
            </div>
          </a>
        </li>

        <li class="filler"></li>

        <li
          *ngIf="isAdmin"
          [style.bottom.px]="footerOffset"
          class="bottom-item"
        >
          <a
            class="menu-item-header ta-navigation"
            [routerLink]="['/admin']"
            routerLinkActive="active"
          >
            <div class="area">
              <img [src]="'assets/icons/person.svg'" alt="admin panel icon" />
            </div>
          </a>
        </li>
      </ul>
    </nav>
  </ng-container>
</div>

<ng-template #expandedMenu>
  <div class="title">
    <p>Medical Areas</p>
    <button
      class="toggle-button"
      role="button"
      (click)="toggleSidebar()"
      aria-label="Collapse sidebar"
    >
      <img src="assets/menu.svg" alt="collapse menu icon" class="expand-icon" />
    </button>
  </div>
  <nav>
    <ul>
      <li *ngFor="let area of therapeuticAreas">
        <button
          class="menu-item-header"
          (click)="expandArea(area, !area.isExpanded)"
          [attr.aria-label]="'Toggle ' + area.name + ' menu'"
          [attr.aria-expanded]="area.isExpanded"
        >
          <div class="area">
            <img
              [src]="'assets/icons/' + area.icon"
              alt="{{ area.name }} icon"
            />
            <p>{{ area.name }}</p>
          </div>
          <mat-icon>{{
            area.isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"
          }}</mat-icon>
        </button>
        <div class="menu-item-body" [class.collapsed]="!area.isExpanded">
          <a
            class="compliance-element-link"
            [routerLink]="['/details', area.name, '']"
            routerLinkActive="active"
            >Overview</a
          >
          <a
            class="compliance-element-link"
            *ngFor="let element of complianceElements"
            [routerLink]="['/details', area.name, element.link]"
            routerLinkActive="active"
            >{{ element.name | titlecase }}</a
          ><br />
        </div>
      </li>
      <li class="filler" aria-hidden="true"></li>
      <li
        class="settings-section"
        *ngIf="isAdmin"
        [style.bottom.px]="footerOffset"
      >
        <p class="settings-header">Settings</p>
        <div class="">
          <a
            class="compliance-element-link settings-link"
            [routerLink]="['admin']"
            routerLinkActive="active"
          >
            <mat-icon>info_outline</mat-icon>
            Admin
          </a>
        </div>
      </li>
    </ul>
  </nav>
</ng-template>
